<i18n
  src="@/locales/views/agro_exporter/quality_reports/container/list_processes.yml"
  lang="yaml"
></i18n>

<template>
  <bread-crumbs :labels="[module_name]"></bread-crumbs>

  <div
    v-if="load_data_general"
    class="bg-white shadow overflow-hidden sm:rounded-md"
  >
    <ul role="list" class="divide-y divide-slate-200">
      <li
        v-for="agroexporter_process in agroexporter_processes"
        :key="agroexporter_process.id"
      >
        <div
          class="block hover:bg-slate-50 cursor-pointer"
          @click.prevent="goToShowProcess(agroexporter_process)"
        >
          <div class="px-4 py-4 sm:px-6">
            <div class="flex items-center justify-between">
              <p class="text-sm font-medium text-gray-900 truncate">
                {{ agroexporter_process.name }}
              </p>
              <div class="ml-2 flex-shrink-0 flex">
                <a class="link invisible sm:visible">
                  <i class="fa-solid fa-eye"></i>
                  <span class="space-icon"></span>{{ $t("labels.show_link") }}
                </a>
              </div>
            </div>
            <div class="mt-2 sm:flex sm:justify-between">
              <div class="sm:flex">
                <p class="flex items-center text-sm text-gray-500">
                  <i
                    class="fa-solid fa-container-storage flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agroexporter_process.num_containers_with_inspects }} /
                  {{ agroexporter_process.num_containers }}
                </p>
                <p
                  class="mt-2 flex items-center text-sm text-gray-500 sm:mt-0 sm:ml-6"
                >
                  <i
                    class="fa-solid fa-box-check flex-shrink-0"
                    aria-hidden="true"
                  />
                  <span class="space-icon"></span>
                  {{ agroexporter_process.num_inspects }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
  <loading-message v-else />
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_reports/container_provider/list_processes.js";

export default {
  name: "AEQualityReportsContainerProviderListProcesses",
  props: ["agro_exporter_id"],
  data() {
    return {
      load_data_general: false,
      agroexporter_processes: []
    };
  },
  methods: {
    fetchAgroExporterProcesses: async function () {
      let response = await Requester.fetchAgroExporterProcesses(
        this.agro_exporter_id
      );
      this.agroexporter_processes = response.data;
      this.load_data_general = true;
    },
    goToShowProcess: function (agroexporter_process) {
      this.$router.push({
        name: "ae_quality_reports_container_provider_show_process_path",
        params: {
          agro_exporter_process_id: agroexporter_process.id
        }
      });
    }
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id
        }
      }).then(() => this.fetchAgroExporterProcesses())
    );
  }
};
</script>
